/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { AiLog } from '@src/app/model/ai-log';

/** Read only - the server registers no write routes for these. */
@Injectable({
    providedIn: 'root'
})
export class AiLogService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);

    protected get baseUrl() {
        return this.getAjaxPath('crm/aiLogs');
    }

    protected cache: AiLog[];
    protected typeString = 'AiLog';
}
